// extracted by mini-css-extract-plugin
export default {"loading":"LoadingCircle_loading__imNH3","spin":"LoadingCircle_spin__e--2l"};